import { theme } from '@acorns/web-components'
import styled from 'styled-components'

import { RECAP_XS_BREAKPOINT } from '../styles'

export const NavBar = styled.div`
  align-items: center;
  background: ${theme.colors.charcoal};
  display: flex;
  height: 84px;
  justify-content: center;
  left: 0;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 39;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    height: 66px;
  }
`
